var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"cookie"}},[(_vm.cookieDivOr)?_c('div',{staticClass:"cookie-div"},[_c('div',[_vm._v("本网站使用Cookie在您的计算机。")]),_c('button',{on:{"click":_vm.closeDiv}},[_vm._v("确 定")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }